import { useTranslation } from 'react-i18next';
import { NavButton } from '@/shared/components/NavButton';
import type { LeaderboardScope, LeaderboardPeriod } from 'shared-types';

const SCOPE_ORDER: LeaderboardScope[] = ['world', 'country'];
const PERIOD_ORDER: LeaderboardPeriod[] = ['all', 'today', 'week', 'month'];

const SCOPE_KEYS = {
  world: 'leaderboard.scopeWorld',
  country: 'leaderboard.scopeCountry'
} as const;

const PERIOD_KEYS = {
  all: 'leaderboard.periodAll',
  today: 'leaderboard.periodToday',
  week: 'leaderboard.periodWeek',
  month: 'leaderboard.periodMonth'
} as const;

interface LeaderboardTabNavProps {
  activeScope: LeaderboardScope;
  activePeriod: LeaderboardPeriod;
  onScopeChange: (scope: LeaderboardScope) => void;
  onPeriodChange: (period: LeaderboardPeriod) => void;
}

export function LeaderboardTabNav({
  activeScope,
  activePeriod,
  onScopeChange,
  onPeriodChange
}: LeaderboardTabNavProps) {
  const { t } = useTranslation();

  const handleScopeClick = () => {
    const currentIndex = SCOPE_ORDER.indexOf(activeScope);
    const nextIndex = (currentIndex + 1) % SCOPE_ORDER.length;
    onScopeChange(SCOPE_ORDER[nextIndex]);
  };

  const handlePeriodClick = () => {
    const currentIndex = PERIOD_ORDER.indexOf(activePeriod);
    const nextIndex = (currentIndex + 1) % PERIOD_ORDER.length;
    onPeriodChange(PERIOD_ORDER[nextIndex]);
  };

  return (
    <div className="flex gap-2">
      <NavButton
        variant="blue"
        arrowDirection="right"
        className="flex-1 h-12"
        onClick={handleScopeClick}
      >
        {t(SCOPE_KEYS[activeScope])}
      </NavButton>
      <NavButton
        variant="blue"
        arrowDirection="right"
        className="flex-1 h-12"
        onClick={handlePeriodClick}
      >
        {t(PERIOD_KEYS[activePeriod])}
      </NavButton>
    </div>
  );
}

export default LeaderboardTabNav;
